import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-tags-component-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.scss'],
  standalone: true,
  imports: [],
})
export class SlideshowComponent {
  img = input<string>();
  alt = input<string>();
  title = input<string>();

  hasImage = computed(() => !!this.img());
}
